import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectSource, selectVillagesLink } from 'shared/selectors';
import { getJsonQuery } from 'shared/selectors/getJsonQuery';

import { trackCountrysideTrapClick, trackCountrysideTrapShow } from './tracking';
import { CountrysideTrapBanner } from '../../serp/components/CountrysideTrapBanner';

export const CountrysideTrapBannerContainer: React.FC = () => {
  const villagesLink = useSelector(selectVillagesLink);

  const jsonQuery = useSelector(getJsonQuery);
  const source = useSelector(selectSource);

  const handleClick = React.useCallback(() => {
    trackCountrysideTrapClick(jsonQuery, source);
  }, [jsonQuery, source]);

  const handleShow = React.useCallback(() => {
    trackCountrysideTrapShow(jsonQuery, source);
  }, [jsonQuery, source]);

  if (!villagesLink) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={handleShow} percentVisible={0.8} triggerOnce>
      <CountrysideTrapBanner onClick={handleClick} villagesLink={villagesLink} />
    </ActionAfterViewObserver>
  );
};
